import classNames from 'classnames';
import dayjs from 'dayjs';
import React from 'react';
import { createUseStyles } from 'react-jss';

function TimeFrom({ time, from, className }) {
  const classes = useStyles();

  return (
    <span className={classNames(classes.container, className)}>
      {dayjs(time).from(dayjs(from))}
    </span>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
  },
});

export { TimeFrom };
